import type { App } from '@cargoflow/api'
import { backOfficeEnv } from '@cargoflow/env/back-office'
import { treaty } from '@elysiajs/eden'

export const api = treaty<App>(backOfficeEnv.BACK_API_URL, {
  fetch: {
    credentials: 'include',
  },
})
